
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";

interface Filter {
  invoice_number: string;
  order_number: string;
  status: string;
  invoice_date_start: string;
  invoice_date_end: string;
  revenue_confirm_time_start: string;
  revenue_confirm_time_end: string;
}
const options = ref({
  status: [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Paid",
      value: "Paid",
    },
    {
      label: "Canceled",
      value: "Canceled",
    },
  ],
  customer: [],
});

export default defineComponent({
  name: "filter-sales-invoice-dropdown",
  components: {},
  emits: ["submit-filter", "reset-filter"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const formRef = ref<null | HTMLFormElement>(null);
    const formData = ref<Filter>({
      invoice_number: "",
      order_number: "",
      status: "",
      invoice_date_start: "",
      invoice_date_end: "",
      revenue_confirm_time_start: "",
      revenue_confirm_time_end: "",
    });

    const submit = () => {
      // console.log(
      //   moment(formData.value.order_date).format("DD.MM.YYYY HH:mm:ss")
      // );
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    return {
      t,
      formData,
      formRef,
      submit,
      handleReset,
      options,
    };
  },
});
